import React from 'react'

export default function TrackerSection({ children }) {
  return (
    <section className="tracker-section">
      {children}
    </section>
  )
}
